/*
  MOVIQ Maattabel (zijpaneel)
  Werkt op de productpagina én in het snel-toevoegen-venster op collectiepagina's
  en de homepage. De link 'Maattabel' naast de maatkeuze (snippets/variant-main-picker.liquid)
  heeft een <template data-moviq-size-template> met de afbeeldingen uit het productmetaveld
  custom.maattabel. Dit script opent die afbeeldingen in één zijpaneel dat boven alles ligt,
  ook boven het snel-toevoegen-venster. Opmaak: assets/moviq-custom.css (.moviq-sg).
*/
(function () {
  if (window.__moviqSizeGuideGlobal) return;
  window.__moviqSizeGuideGlobal = true;

  var dialog = null;

  function getDialog() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'moviq-sg';
    dialog.id = 'MoviqSizeGuide';
    dialog.setAttribute('aria-labelledby', 'MoviqSizeGuideTitle');
    dialog.innerHTML =
      '<div class="moviq-sg__panel">' +
      '<div class="moviq-sg__header">' +
      '<h2 class="moviq-sg__title" id="MoviqSizeGuideTitle">Maattabel</h2>' +
      '<button type="button" class="moviq-sg__close" data-moviq-size-close aria-label="Sluiten">' +
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="moviq-sg__body"></div>' +
      '</div>';

    // Klikken en toetsen in het paneel niet laten 'doorlekken' naar het
    // snel-toevoegen-venster eronder (dat zou anders kunnen sluiten).
    ['click', 'pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (type) {
      dialog.addEventListener(type, function (event) {
        event.stopPropagation();
      });
    });

    dialog.addEventListener('click', function (event) {
      // Klik op de achtergrond (buiten het paneel) of op het kruisje sluit het paneel
      if (event.target === dialog || event.target.closest('[data-moviq-size-close]')) {
        dialog.close();
      }
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-moviq-size-open]');
    if (!link) return;

    var template = link.parentElement && link.parentElement.querySelector('template[data-moviq-size-template]');
    if (!template) return;

    event.preventDefault();
    event.stopPropagation();

    var d = getDialog();
    var body = d.querySelector('.moviq-sg__body');
    body.replaceChildren(template.content.cloneNode(true));
    body.scrollTop = 0;

    if (!d.open) d.showModal();
  });
})();
